module.exports = __webpack_public_path__ + "img/ico_info_gray.bbf6de27.svg";